import {useCallback, useState} from "react"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"
import {useDispatch} from "react-redux"
import {authAPI, AuthSSOResponse} from "../../api/authAPI"

export const useAuthThroughSSO = (onSuccess: (response: AuthSSOResponse) => void) => {
    const [status, setStatus] = useState(APIStatus.Initial)
    const dispatch = useDispatch()
    const auth = useCallback(
        (email: string) => {
            setStatus(APIStatus.Loading)
            dispatch(
                authAPI.sso_url({
                    payload: {
                        email,
                    },
                    onSuccess: (response) => {
                        setStatus(APIStatus.Success)
                        onSuccess(response)
                    },
                    onError: () => {
                        setStatus(APIStatus.Failure)
                    },
                })
            )
        },
        [dispatch]
    )

    return {
        status,
        auth,
    }
}
